import React from 'react';
import { Container, Title, Text, Button, Group, Image, Card } from '@mantine/core';
import { Link, useLocation } from '@tanstack/react-router';
import { IconArrowLeft, IconShieldLock } from '@tabler/icons-react';

export function Unauthorized() {
  const location = useLocation();
  const path = location.pathname;
  
  // Determina il messaggio basato sul percorso
  let message = "Non hai i permessi necessari per accedere a questa pagina.";
  
  if (path.startsWith('/admin')) {
    message = "Questa area è riservata agli amministratori.";
  } else if (path.startsWith('/products/new')) {
    message = "Non hai il permesso di aggiungere nuovi prodotti.";
  } else if (path.startsWith('/products/') && !path.endsWith('/new')) {
    message = "Non hai il permesso di modificare i prodotti.";
  }
  
  return (
    <Container size="md" py={80}>
      <Card withBorder shadow="md" p="xl" radius="md">
        <Group mb="xl" justify="center">
          <IconShieldLock size={50} color="red" />
        </Group>
        
        <Title order={1} ta="center" mb="xl">Accesso Negato</Title>
        
        <Text size="xl" ta="center" mb="xl">
          {message}
        </Text>
        
        <Group justify="center" mt="xl">
          <Button
            component={Link}
            to="/"
            leftSection={<IconArrowLeft size={20} />}
            variant="outline"
            size="md"
          >
            Torna alla Dashboard
          </Button>
        </Group>
      </Card>
    </Container>
  );
}